var _style, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 376.12 147.4",
    style: {
      enableBackground: "new 0 0 376.12 147.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FAED33;}\n\t.st1{fill:#1F2326;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.22,
    y: 0.28,
    className: "st0",
    width: 376.35,
    height: 147.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "34.4,34.55 34.4,58.72 34.44,58.77 88.97,58.77 88.97,89.05 58.69,89.05 58.69,61.8 34.47,61.8  34.47,113.26 113.19,113.26 113.19,34.55  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M140.43,58.77v54.49h-24.22V34.55h78.71v51.47h-17.2l17.2,27.25h-35.75l-15.72-27.25V61.8h27.25v-3.03H140.43z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M287.23,58.85v54.49h-24.22V34.63h78.71v51.47h-17.2l17.2,27.25h-35.75l-15.72-27.25V61.87h27.25v-3.03H287.23 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M259.76,34.55l-0.22,34.49l-44.22,44.22h-17.14V34.55h24.22v37.36L259.76,34.55z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBackground);
export default __webpack_public_path__ + "static/media/logo-background.17e99c504363707ca0a9d4cd944528ad.svg";
export { ForwardRef as ReactComponent };